import React from 'react';
import {Link} from 'react-router-dom';
import emptyQuoteObj from '../utilities/emptyQuoteObj';
import { useStore } from '../StoreProvider';
import { ACTIONS } from '../Actions';

const NavbarOps = ({pathname, setPathname}) => {
    const { dispatch } = useStore();
    const resetNav = () => {
        dispatch({ type: ACTIONS.QUOTE, payload: emptyQuoteObj });
        dispatch({ type: ACTIONS.NAVBAR_QUOTE_ID, payload: "" });
    };
    return (
        <div className="width-100">
            <ul className='flex-row list-none pad-md bg-orange gap-xlg justify-start'>

                <li className='text-white text-smedium no-underline text-bold first-link-nav' 
                onClick={()=>{resetNav();
                setPathname ('/operations/zoho')}}>
                    <Link to="/operations/zoho" className={`no-underline ${pathname === '/operations/zoho' ? 'text-black' : 'text-white'}`}>
                        Stock Sheet
                    </Link>
                </li>
             
            </ul>
        </div>
    );
};

export default NavbarOps;
